import {
  getAllPrimaryTopics,
  getInfluencesArray,
} from "@/services/events/topics.service";

import { STATIC_RESOURCES_PATH } from "@/common/constants/api";
import { HYPERION_API_DOMAIN } from "@/common/config";

export const WB_MAP_LAYERS = `${HYPERION_API_DOMAIN}/tiles/maps/workbench/{z}/{x}/{y}.pbf`;
export const LAT_LNG_PRECISION = 4;
export const MAIN_MAP_ID = "main_map";
export const LAYER_ID_ACETATE = "acetate";
export const LAYER_ID_ACETATE_UNDER = "acetate_under";
export const DEFAULT_OPACITY = 0.35;
export const DEFAULT_OPACITY_PULSE = 0.5;
export const MAP_PRECISIONS = {
  min: 5,
  max: 9,
};

export const DEFAULT_LAYERS_DETAILS = {
  custom_satellite: {
    font: "Arial Regular",
    dark: true,
    style: `${STATIC_RESOURCES_PATH}/map_styles/style_satellite.json`,
  },
  custom_satellite_dark: {
    font: "Arial Regular",
    dark: true,
    style: `${STATIC_RESOURCES_PATH}/map_styles/style_satellite_dark.json`,
  },
  esri_world_street: {
    font: "Arial Regular",
    dark: false,
    style:
      "https://www.arcgis.com/sharing/rest/content/items/de26a3cf4cc9451298ea173c4b324736/resources/styles/root.json?f=pjson",
  },
  esri_nova: {
    font: "Audiowide Regular",
    dark: true,
    style:
      "https://www.arcgis.com/sharing/rest/content/items/75f4dfdff19e445395653121a95a85db/resources/styles/root.json?f=pjson",
  },
  esri_night_time: {
    font: "Ubuntu Medium",
    dark: true,
    style:
      "https://www.arcgis.com/sharing/rest/content/items/c11ce4f7801740b2905eb03ddc963ac8/resources/styles/root.json?f=pjson",
  },
  esri_light: {
    font: "Ubuntu Regular",
    dark: false,
    style:
      "https://www.arcgis.com/sharing/rest/content/items/8a2cba3b0ebf4140b7c0dc5ee149549a/resources/styles/root.json?f=pjson",
  },
};

let tilesSourceNameCountry = "stability-country-grid.json";
let tilesSourceLayerCountry = "PulseCountryStability";
let tilesSourceLayerForecastCountry = "PulseCountryStabilityForecast";
let tilesSourceNameRegion = "stability-region-grid.json";
let tilesSourceLayerRegion = "PulseRegionStability";
let tilesSourceLayerForecastRegion = "PulseRegionStabilityForecast";
let tilesSourceNameCity = "stability-city-grid.json";
let tilesSourceLayerCity = "PulseCityStability";
let tilesSourceLayerForecastCity = "PulseCityStabilityForecast";
let tilesSourceNameCounty = "stability-county-grid.json";
let tilesSourceLayerCounty = "PulseCountyStability";
let tilesSourceLayerForecastCounty = "PulseCountyStabilityForecast";

export const TILES_SOURCE_NAMES_STABILITY_COUNTRY = tilesSourceNameCountry;
export const TILES_SOURCE_NAMES_STABILITY_REGION = tilesSourceNameRegion;
export const TILES_SOURCE_NAMES_STABILITY_CITY = tilesSourceNameCity;
export const TILES_SOURCE_NAMES_STABILITY_COUNTY = tilesSourceNameCounty;
export const TILES_SOURCE_NAMES = {
  country: TILES_SOURCE_NAMES_STABILITY_COUNTRY,
  region: TILES_SOURCE_NAMES_STABILITY_REGION,
  city: TILES_SOURCE_NAMES_STABILITY_CITY,
  county: TILES_SOURCE_NAMES_STABILITY_COUNTY,
};

export const TILES_SOURCE_LAYERS_STABILITY_COUNTRY = tilesSourceLayerCountry;
export const TILES_SOURCE_LAYERS_STABILITY_REGION = tilesSourceLayerRegion;
export const TILES_SOURCE_LAYERS_STABILITY_CITY = tilesSourceLayerCity;
export const TILES_SOURCE_LAYERS_STABILITY_COUNTY = tilesSourceLayerCounty;
export const TILES_SOURCE_LAYERS = {
  country: TILES_SOURCE_LAYERS_STABILITY_COUNTRY,
  region: TILES_SOURCE_LAYERS_STABILITY_REGION,
  city: TILES_SOURCE_LAYERS_STABILITY_CITY,
  county: TILES_SOURCE_LAYERS_STABILITY_COUNTY,
};

export const TILES_FORECAST_SOURCE_LAYERS_STABILITY_COUNTRY = tilesSourceLayerForecastCountry;
export const TILES_FORECAST_SOURCE_LAYERS_STABILITY_REGION = tilesSourceLayerForecastRegion;
export const TILES_FORECAST_SOURCE_LAYERS_STABILITY_CITY = tilesSourceLayerForecastCity;
export const TILES_FORECAST_SOURCE_LAYERS_STABILITY_COUNTY = tilesSourceLayerForecastCounty;
export const TILES_FORECAST_SOURCE_LAYERS = {
  country: TILES_FORECAST_SOURCE_LAYERS_STABILITY_COUNTRY,
  region: TILES_FORECAST_SOURCE_LAYERS_STABILITY_REGION,
  city: TILES_FORECAST_SOURCE_LAYERS_STABILITY_CITY,
  county: TILES_FORECAST_SOURCE_LAYERS_STABILITY_COUNTY,
};

export const CLUSTER_LAYER_SUFFIX = "-marker-cluster";

let mapIconColors = {
  alerts: "#F92E7F",
  disasters: "#5B3AFF",
  travel: "#FB8F8E",
  news: "#DBB85A",
  social: "#00ACEE",
};

let mapIconNames = {
  travel: "travel",
  disasters: "disasters",
  news: "news",
  alerts: "alerts",
  hotspots: "hotspots",
  hotspotsSelected: "hotspotsSelected",
  places: "places",
  locationsEdit: "locationsEdit",
  locations: "locations",
  social: "social",
  diplomacy_china_political: "diplomacy_china_political",
  diplomacy_china_economic: "diplomacy_china_economic",
  diplomacy_china_social: "diplomacy_china_social",
  diplomacy_china_infrastructure: "diplomacy_china_infrastructure",
  diplomacy_china_military: "diplomacy_china_military",
  diplomacy_china_information: "diplomacy_china_information",
};

export function setTopicsIcons() {
  // add the event topics icon colors and names to the main lists
  let PRIMARY_TOPICS = getAllPrimaryTopics();
  PRIMARY_TOPICS.map((topic) => {
    mapIconColors[topic.type] = topic.mapIconColor ? topic.mapIconColor : null;
    mapIconNames[topic.type] = topic.type;
  });

  // add the event topics icon colors and names to the main lists
  const INFLUENCES_ARRAY = getInfluencesArray();
  INFLUENCES_ARRAY.map((topic) => {
    mapIconNames[topic.type] = topic.type;
  });
}

export const MAP_ICON_COLORS = mapIconColors;
export const MAP_ICON_NAMES = mapIconNames;

export const MAP_ATTRIBUTION = {
  vector:
    "Source: Esri, HERE, Garmin, FAO, NOAA, USGS, ©OpenStreetMap contributors, and the GIS User Community",
  imagery:
    "Imagery Source: Esri, Maxar, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community",
};

export const MI_TO_KM_CONVERSION_FACTOR = 0.621371;
